export default class rModelsBase extends Object {
  constructor() {
    super();
  }
}
